import axios from "axios";

export const API_URL = "https://api.sgllegal.co.uk:3000";

export const axiosInstance = axios.create({
                                            baseURL: API_URL,
                                            headers: {"Content-Type": "application/json"}
                                          });